import { render, staticRenderFns } from "./PostArticle.vue?vue&type=template&id=7bb77473&"
import script from "./PostArticle.vue?vue&type=script&lang=js&"
export * from "./PostArticle.vue?vue&type=script&lang=js&"
import style0 from "./PostArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports